export const common = {
  'plsEnter': '請輸入',
  'plsSelect': '請選擇',
};

export default {
  kline: {
    '0m': '分時',
    '1m': '1分',
    '5m': '5分',
    '15m': '15分',
    '30m': '30分',
    '1h': '1小時',
    '1d': '1天',
    '1w': '1週',
  },
  depositStatus: {
    0: '待入帳',
    1: '充值成功',
    2: '到賬失敗',
  },
  withdrawStatus: {
    0: '審核中',
    1: '成功',
    2: '拒絕',
    3: '撤銷',
    4: '審核通過',
    5: '打幣中',
    6: '錢包異常，審核中',
  },
  map: {
    orderCategory: {
      1: '買入',
      2: '賣出',
    },
    orderType: {
      1: '限價',
      2: '市價',
    },
    myOrderStatus: {
      0: '待成交',
      1: '已成交',
      2: '取消',
    },
  },

  links: {
    announcement: 'https://grxtrade.s2.udesk.cn/hc/sections/20627?api_name=',
    fees: 'https://grxtrade.s2.udesk.cn/hc/sections/20630?api_name=',
    webGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20616?api_name=',
    appGuide: 'https://grxtrade.s2.udesk.cn/hc/sections/20622?api_name=',
  },

  'about.title': '關於GRXTrade',
  'about.desc': '全球幣幣交易費是以最低的收費並出現在最先進的數字資產交易所GRXTrade。一個平台上擁有這兩個最好的功能。 ',
  'about.learnMore': '了解更多',

  'advanced.lvl2Verf': '等級2認證',
  'advanced.address.info': '居住地址',
  'advanced.address.proofOfAddress': '住址證明為官方或司法機關發出的文件，物業賬單或銀行文件，（必須全頁顯示及姓名必須與一級認證)',
  'advanced.address.building': '建築號碼',
  'advanced.address.street': '街',
  'advanced.address.district': '區域',
  'advanced.address.province': '省',
  'advanced.address.zipCode': '郵政號碼',
  'advanced.address.city': '市',
  'advanced.address.authImgUrl1': '上傳地址證明文件',
  'advanced.address.successSave': '居住地址已成功保存',

  'advanced.employment.info': '就業資料',
  'advanced.employment.proofOfIncomeDocuments': '收入證明為：工資單，銀行月結單，報稅單，融資合同 （必須全頁顯示及姓名必須與一級認證)',
  'advanced.employment.employStatus': '就業狀態',
  'advanced.employment.sourceIncome': '收入來源',
  'advanced.employment.sourceIncomeName': '收入來源',
  'advanced.employment.industry': '行業',
  'advanced.employment.industryName': '行業',
  'advanced.employment.jobTitle': '職位',
  'advanced.employment.companyName': '公司名稱',
  'advanced.employment.employerBuilding': '建築號碼',
  'advanced.employment.employerStreet': '街',
  'advanced.employment.employerZipCode': '郵政號碼',
  'advanced.employment.employerCity': '市',
  'advanced.employment.employerDistrict': '區域',
  'advanced.employment.employerProvince': '省',
  'advanced.employment.authImgUrl2': '上傳收入證明文件',
  'advanced.employment.successSave': '就業資料已成功保存',

  'affiliate.title': '會員計劃',
  'affiliate.title.desc': '參與GRXTrade平台優質的會員計劃，為您奉上最豐厚的利潤回報',
  'affiliate.actions.joinNow': '立即加入',
  'affiliate.desc.1': 'GRXTrade平台方旨在通過其推出的會員計劃，使您的交易增長潛力和盈利能力最大化。 ',
  'affiliate.desc.2': '每個人都可以加入我們的會員計劃！此计划利潤豐厚，立即加入開始賺錢吧。交易者將獲得最低20%、累計最高40%的交易手續費佣金。收益遠遠不止於此。只要您推薦的會員附保持一定的活躍度，您將可以持續獲得佣金。',
  'affiliate.desc.3': '市場上大多數同行業者僅在有限的時間內提供類似的福利，但是，GRXTrade平台的員計劃將無限期為我們的用戶帶來高額收益。',
  'affiliate.desc.4': '還在猶豫什麼？立即加入GRXTrade會員計劃，拓展您的交易潛力與交易深度吧。',
  'affiliate.whyJoin.title': '為什麼要加入會員計劃？',
  'affiliate.whyJoin.desc.1': '市場最佳佣金率和獎金福利',
  'affiliate.whyJoin.desc.2': '頂級會員可享受專屬特權並獲得第一手資訊',
  'affiliate.whyJoin.desc.3': '專屬客戶經理，支持您的業務拓展',
  'affiliate.whyJoin.desc.4': '通過我們精心設計的會員計劃的平台與架構，為您拓展潛在市場',
  'affiliate.whyJoin.desc.5': '永久返佣機會',
  'affiliate.works.title': '會員計劃的具體規則',
  'affiliate.works.desc': 'GRXTrade不僅是一個為全球用戶提供金融級數字資產交易和資產管理服務的數字資產交易所，其同時可提供相應的增值方案，投資者通過會員計劃獲得可持續性的收益',
  'affiliate.works.notes': '注:',
  'affiliate.works.tip.1': '目前在線視頻課程以中文講解為主。我們將適時推出英文課程。',
  'affiliate.works.tip.2': '專屬獎勵僅適用於高級會員和頂級會員。',
  'affiliate.sharing.title': '會員計劃分潤體系',
  'affiliate.sharing.normal.title': '普通會員',
  'affiliate.sharing.senior.title': '高級會員',
  'affiliate.sharing.top.title': '頂級會員',
  'affiliate.sharing.top.notEligible': '無學習獎勵',
  'affiliate.sharing.top.earnReward': '可從每位直接下級處獲得高達40％的學習獎勵',
  'affiliate.sharing.joining.fee': '免费',
  'affiliate.sharing.commission.20': '享有旗下直接用戶交易手續費的20%',
  'affiliate.sharing.commission.20.senior': '享有旗下直接用戶交易手續費的20%',
  'affiliate.sharing.fee.200': '費用:200 USDT/年',
  'affiliate.sharing.commission.1st.level': '享有旗下間接用戶交易手續費的10%',
  'affiliate.sharing.fee.rebate': '享有手續費折扣300USDT',
  'affiliate.sharing.fee.rebate2': '享有手续费折扣200USDT',
  'affiliate.sharing.fee.300': '費用:300 USDT/年',
  'affiliate.sharing.commission.2nd.level': '享有旗下二級間接用戶交易手續費的10%',
  'affiliate.sharing.wdec2': '享有WDEC（教育网站）价值1980USDT的实战培训课程，且享有指定商学院免费的线下学习机会。',
  'affiliate.sharing.wdec': '享有WDEC（教育網站）價值2980USDT的實戰培訓課程，且享有指定商學院免費的線下學習機會。',

  'affiliateInvite.title': 'GRXTrade會員計劃',
  'affiliateInvite.seniorAffiliate.memberFee': '會員費',
  'affiliateInvite.title.desc.1': '客戶經理將分配給所有合格的VIP用戶，提供24/7全天候的支持。 ',
  'affiliateInvite.title.desc.2': 'VIP用戶登錄後可以在VIP客戶中心查尋其客戶經理的聯繫信息。 ',
  'affiliateInvite.btn': '立即加入',
  'affiliateInvite.upgrade': '立即升級',
  'affiliateInvite.joinAffiliateProgram.title': '加入會員計劃',
  'affiliateInvite.joinAffiliateProgram.desc': '若要繼續，MAX-Wallet將與grxtrade.com共享您的身份信息。在使用GRXTrade應用之前，請閱讀我們的使用條款。 ',

  'affiliateInvite.joinAffiliateModal.affiliateLevel': '會員級別：',
  'affiliateInvite.joinAffiliateModal.fee': '培訓費：',
  'affiliateInvite.joinAffiliateModal.termsAndCondition': '在此點擊此按鈕，即表示您同意會員計劃的<a href="/legal/affiliate-policy" target="_blank" style="color: #1E49AC">條款與條件</a>',
  'affiliateInvite.joinAffiliateModal.balance': '我的資產餘額：',
  'affiliateInvite.joinAffiliateModal.mustCheckText': '您必須同意條款和條件才能繼續進行',

  'actions.back': '返回',
  'actions.cancel': '取消',
  'actions.close': '關閉',
  'actions.contactUs': '聯絡我們',
  'actions.copy': '複製',
  'actions.copyAll': '複製全部',
  'actions.export': '導出',
  'actions.filter': '篩選',
  'actions.confirm': '確定',
  'actions.delete': '刪除',
  'actions.reject': '拒絕',
  'actions.download': '下載',
  'actions.login': '登錄',
  'actions.loginNow': '立即登錄',
  'actions.loginMaxWallet': '使用MAX-Wallet登錄',
  'actions.payNow': '立即付款',
  'actions.payingNow': '正在付款',
  'actions.registMaxWallet': '使用MAX-Wallet註冊',
  'actions.registNow': '立即註冊',
  'actions.register': '註冊',
  'actions.renew': '更新',
  'actions.save': '保存',
  'actions.sendEmailOtp': '發送郵箱驗證碼',
  'actions.sendOtp': '發送驗證碼',
  'actions.submit': '提交',
  'actions.tradeCancel': '撤銷',
  'actions.tradeCancelAll': '撤銷全部',
  'actions.deposit': '充幣',
  'actions.withdraw': '提幣',
  'actions.setup': '設置',
  'actions.modify': '修改',
  'actions.search': '搜索',

  'common.selectCountry': '選擇國家',
  'common.noRecords': '暫無數據',
  'common.loading': '加載中',
  'common.recordsPerPage': '每頁的記錄',
  'common.all': '全部',
  'common.expired': '期至',
  'common.validUntil': '有效期至',
  'common.verifyCount': '{time}秒後重發',
  'common.userCount': '總用戶',
  'common.noData': '',
  'common.rowPerPage': '頁數',

  'company.profile.title': '公司簡介',
  'company.profile.desc.1': '2017年提出的想法最終在兩年後得以實現。 GRXTrade是新一代數字資產交易服務平台。 ',
  'company.profile.desc.2': '我們的願景是通過創建一個面向行業4.0的加密金融中心來塑造未來的全球經濟，該中心專注於提供多種交易選項的區塊鏈技術，全天候個人客戶支持服務以及卓越的平台安全功能。 ',
  'company.profile.vision': '願景',
  'company.profile.vision.desc.1': '目前，市場上充斥著大量的加密交易平台可供交易者選擇，但有時又難以挑選到最優的交易平台。值得注意的是，過多交易平台的存在將帶來流動性低的問題。其中許多交易所僅在特定國家運營，更糟糕的是，其中一些交易平台還可能存在欺詐性質。 ',
  'company.profile.vision.desc.2': 'GRXTrade計劃憑藉最優的市場交易費用和最受歡迎的交易對來服務於國際市場交易者，從而提升交易所的運作水平。本交易所平台將與Oneness生態系統通證(即OEP通證)相融合，通過與其他交易所網絡共享流動性，消除低流動性所帶來的風險。 ',
  'company.profile.features': '特點',
  'company.profile.features.subheader': '是什麼讓GRXTrade成為獨特的加密交易平台？ ',
  'company.profile.features.title.1': '安全',
  'company.profile.features.title.2': '最低交易費',
  'company.profile.features.title.3': '會員項目',
  'company.profile.features.title.4': '智能交易者',
  'company.profile.features.desc.1': 'GRXTrade由全球懷有共同理念和追求共同願景的技術領域企業家所創立，該願景即旨在提供基於區塊鏈技術的金融科技產品，以創造更多具有包容性的且受道德約束的金融準入機。',
  'company.profile.features.desc.2': '自2017年成立以來，GRXTrade始終致力於通過不斷開拓創新的方式，憑藉全面、智能化的金融工具將金融科技與傳統金融相結合，打造未來的全球數字經濟模式，造福大眾的日常生活。',
  'company.profile.features.desc.3': 'GRXTrade創始團隊主要來自金融和IT行業，所有成員均為在各自行業擁有15年以上經驗的資深人士，此前主要擔任外匯、金融行業、加密交易和信息技術行業顧問。 GRXTrade的綜合管理和技術團隊是分散化的，同時，我們的業務遍及中國、中國台灣、新加坡、韓國、日本和阿拉伯聯合酋長國的多個主要城市。',
  'company.profile.features.desc.4': '本團隊很早便衍生出開發加密交易平台的想法，根據我們的計劃，該平台將不同於僅提供標準產品功能與服務的普通交易平台。終於，經過短短不到三年的時間，GRXTrade即將作為一個符合歐洲國家法規監管的、遠超越普通數字資產交易平台的創新型平台，於2020年第一季度正式面市。',
  'company.profile.last.word': '即刻加入GRXTrade 為您的未來投資',

  'contactUs.title': '聯絡我們',
  'contactUs.desc.1': '如需更多諮詢，您可以向我們發送電子郵件至',
  'contactUs.desc.2': '我們將在24小時內回复所有查詢。萬一有任何延遲的方面，我們非常感謝您的理解和支持。 ',
  'contactUs.desc.3': '貴客請放心，我們的客戶支持團隊經過了專業培訓，能夠處理客戶的任何疑慮。 ',

  'dealProfessional.kLine.text': 'K線',
  'dealProfessional.depth.text': '深度圖',
  'dealProfessional.original.text': '原版k線',
  'dealProfessional.buyEntrust': '買盤委託',
  'dealProfessional.sellEntrust': '賣盤委託',
  'dealProfessional.price': '价格',
  'dealProfessional.sum': '累計',

  'fee.title': '交易費用結構',
  'fee.desc.1': '我們提供鎮上',
  'fee.lowest': '最低',
  'fee.desc.2': '的交易費.',
  'fee.desc.3': '選擇GRXTrade來進行交易，以增長您的盈利能力和回報。 ',
  'fee.reference.text': '下表是我們的交易費用結構，僅供參考。 ',
  'fee.vip.level.title': 'VIP 等級',
  'fee.trade.volume.title': '30天交易量 (USDT)',
  'fee.all.zone.title': '全區',
  'fee.maker.title': '製作者',
  'fee.taker.title': '接收者',
  'fee.vip.normal': '普通',
  'fee.vip.level.1': '第一級',
  'fee.vip.level.2': '第二級',
  'fee.vip.level.3': '第三級',
  'fee.vip.level.4': '第四級',
  'fee.vip.level.5': '第五級',
  'fee.volume.1.million': '0 ≤ 100萬的體積',
  'fee.volume.5.million': '100萬 ≤ 體積 ≤ 500萬',
  'fee.volume.35.million': '500萬 ≤ 體積 ≤ 3500萬',
  'fee.volume.100.million': '3500萬 ≤ 體積 ≤ 1億',
  'fee.volume.300.million': '1億 ≤ 體積 ≤ 3億',
  'fee.volume.over.300.million': '≥ 3億',
  // 'fee.withrawal.title': 'Withdraw Fee',
  // 'fee.withrawal.asset.type': 'Asset Type',
  // 'fee.withrawal.withdrawal.fees': 'Withdrawal Fees',
  // 'fee.withrawal.min.withdraw': 'Minimum Withdrawal',
  // 'fee.withrawal.term.1': '* The transaction fee will be deducted from your total transaction amount.',
  // 'fee.withrawal.term.2': '* Fees are regularly adjusted according to market conditions. ',
  // 'fee.withrawal.term.3': '* All the information given above is up-dated.',

  'footer.aboutGrx': '關於 GRXTrade',
  'footer.aboutGrx.aboutUs': '關於我們',
  'footer.aboutGrx.contactUs': '聯繫我們',
  'footer.aboutGrx.companyProfile': '公司背景',
  'footer.aboutGrx.affProgram': ' 會員計劃',
  'footer.aboutGrx.fees': '費率',
  'footer.aboutGrx.teamProfile': '公司管理層',
  'footer.aboutGrx.helpCenter': '幫助中心',
  'footer.aboutGrx.helpCenter.web': '電腦版',
  'footer.aboutGrx.helpCenter.app': '手機版',

  'footer.legal': '法律',
  'footer.legal.termsOfUse': '使用條款',
  'footer.legal.amlPolicy': '反洗錢與打擊資助恐怖主義政策',
  'footer.legal.riskStatement': '風險披露聲明',
  'footer.legal.privacyPolicy': '隱私政策',
  'footer.legal.affiliatePolicy': '會員政策',
  'footer.legal.partnerPolicy': '合夥人政策',

  'header.assets': '資產',
  'header.downloadApp': '下載App',
  'header.exchange': '幣幣交易',
  'header.login': '登錄',
  'header.markets': '行情',
  'header.register': '註冊',
  'header.orders': '訂單',
  'header.announcement': '公告中心',
  'header.helpCenter': '幫助中心',

  'header.user.drop.verification': '身份認證',
  'header.user.drop.fee.setting': '費率設置',
  'header.user.drop.invite': '邀請好友',
  'header.user.drop.member.level': '會員等級',
  'header.user.drop.vip.level': 'VIP',
  'header.user.drop.30d.vol': '30天量',
  'header.user.drop.logout': '退出',

  'labels.actions': '操作',
  'labels.reminder': '溫馨提示',
  'labels.confirmation': '確認',
  'labels.confirmPwd': '確認密碼',
  'labels.date': '時間',
  'labels.joinDate': '加入時間',
  'labels.cdate': '創建時間',
  'labels.mdate': '更新時間',
  'labels.email': '郵箱',
  'labels.emailOtp': '郵箱驗證碼',
  'labels.mobileNo': '手機號碼',
  'labels.ga': '谷歌驗證',
  'labels.gaCode': '谷歌驗證碼',
  'labels.unbind': '重新綁定',
  'labels.orderId': '訂單ID',
  'labels.tradeId': '交易ID',
  'labels.pwd': '密碼',
  'labels.setup': '設置',
  'labels.view': '查看',
  'labels.txnPwd': '交易密碼',
  'labels.loading': '加載',
  'labels.language': '語言',
  'labels.add': '添加',
  'labels.uid': 'UID',
  'labels.postDate': '公佈日期：',
  'labels.feeCategory': '收費類別',
  'labels.commissionsEarned': '賺取的佣金',
  'labels.reset': '重置',
  'labels.maxRegister': '授權MAX-Wallet登錄',

  'labels.transaction.assetType': '資產類型',
  'labels.transaction.from': '時間開始',
  'labels.transaction.to': '時間結束',
  'labels.transaction.time': '時間',
  'labels.transaction.coin': '幣種',
  'labels.transaction.id': 'ID',
  'labels.transaction.type': '類別',
  'labels.transaction.total': '總數',
  'labels.transaction.freeze': '凍結',
  'labels.transaction.remark': '備註',
  'labels.transaction.freezeamount': '凍結數量',
  'labels.transaction.availablebalance': '可用數量',
  'labels.transaction.freezeAsset': '凍結資產',
  'labels.transaction.availableAsset': '可用資產',
  'labels.transaction.beforeAmount': '金額前',
  'labels.transaction.changeAmount': '改換金額',
  'labels.transaction.afterAmount': '金額後',
  'labels.transaction.fee': '費用',
  'labels.transaction.today': 'Today',
  'labels.transaction.sevenday': '7 day',
  'labels.transaction.fifteen': '15 day',
  'labels.transaction.thirty': '30 day',
  'labels.transaction.all': 'All',
  'labels.transaction.search': '搜索',

  'labels.trade.market': '市場',
  'labels.trade.coinOrders': '訂單管理',
  'labels.trade.buy': '買入',
  'labels.trade.sell': '賣出',
  'labels.trade.pair': '交易對',
  'labels.trade.side': '方向',
  'labels.trade.type': '方式',
  'labels.trade.amt': '交易額',
  'labels.trade.dealAmt': '成交額',
  'labels.trade.dealVol': '成交量',
  'labels.trade.history.vol': '成交量',
  'labels.trade.vol': '數量',
  'labels.trade.price': '價格',
  'labels.trade.orderVol': '委託數量',
  'labels.trade.orderPrice': '委託價格',
  'labels.trade.avgPrice': '成交均價',
  'labels.trade.change': '漲幅',
  'labels.trade.24change': '24H漲幅',
  'labels.trade.24high': '24H高',
  'labels.trade.24low': '24H低',
  'labels.trade.24vol': '24H量',
  'labels.trade.limit': '限價交易',
  'labels.trade.tradeHistory': '實時成交',
  'labels.trade.time': '時間',
  'labels.trade.latestPrice': '最新價',
  'labels.trade.startTrade': '開始交易',
  'labels.trade.add.sessionTxnPwd': '記住交易密碼',
  'labels.trade.depth': '深度',
  'labels.trade.fee': '交易費',
  'labels.trade.rebate': '折扣',
  'labels.trade.paidFee': '實際支付',
  'labels.trade.resultAmt': '獲取金額',

  'labels.reward.title': '剩餘獎勵會員數',
  'labels.reward.human': '人',
  'labels.reward.10.mxw': '立即獲取您的10MXW！',
  'labels.reward.tnc': '滿足條件:',
  'labels.reward.tnc.1': '1。用戶註冊和完成實名認證',
  'labels.reward.tnc.2': '2。至少有1個邀請',

  'labels.status': '狀態',
  'labels.openOrders': '當前委託',
  'labels.or': '或',
  'labels.orderHistory': '歷史委託',
  'labels.orders': '訂單',
  'labels.otp': '驗證碼',
  'labels.remarks': '備註',

  'labels.scanQrCode': '請掃描MAX-Wallet應用程序中的二維碼開始認證',
  'labels.wechatQrCode': '官方客服群',

  'labels.finance.coinToCoinAcc': '財務管理',
  'labels.finance.coin': '幣種',
  'labels.finance.available': '可用',
  'labels.finance.freeze': '凍結',
  'labels.finance.total': '總數',
  'labels.finance.records': '財務記錄',
  'labels.finance.transaction': '賬戶報表',
  'labels.finance.addrMgmt': '提幣地址管理',
  'labels.finance.walletAddr': '地址',
  'labels.finance.depositAddr': '充值地址',
  'labels.finance.withdrawalAddr': '提幣地址',
  'labels.finance.memo': '地址標籤',
  'labels.finance.memo.notes': '（填寫錯誤可能導致資產損失，請仔細核對）',
  'labels.finance.depositRecords': '充幣記錄',
  'labels.finance.withdrawRecords': '提幣記錄',
  'labels.finance.actualAmt': '到賬數量',
  'labels.finance.qty': '數量',
  'labels.finance.fee': '手續費',
  'labels.finance.recharge.tips': '地址標籤和充幣地址同時正確填寫才能充值到G平台，遺漏地址標籤將導致資金丟失！',
  'labels.finance.withdraw.riskWarning': '風險提示',
  'labels.finance.withdraw.riskWarning.desc.1': '您的提幣操作一旦完成，對應的資產所有權將由您變更為目標地址所對應的賬戶所有人享有。',
  'labels.finance.withdraw.riskWarning.desc.2': '請您務必在提幣操作前，仔細核對提幣地址信息，確保提幣屬於自願行為，並確認不涉及任何傳銷、非法集資、詐騙等違法情形，謹防上當受騙，避免造成不必要的財產損失。',

  'labels.acc.inviteFriend': '邀請好友',
  'labels.acc.upgradeToPartner': '升級合夥人',
  'labels.acc.feeLevel': '費率等級',
  'labels.acc.kyc': '實名認證',
  'labels.acc.advKyc': '高級認證',
  'labels.acc.pass': '已通過',
  'labels.acc.notPass': '未通過',
  'labels.acc.securitySettings': '安全設置',
  'labels.acc.bindEmail': '綁定郵箱',
  'labels.acc.bindEmail.desc': '獲取每週最新的技術分析，新聞和促銷活動。 ',
  'labels.acc.ga.desc': '資產提現、修改密碼及安全設置時需要輸入谷歌驗證碼。 ',
  'labels.acc.ga.desc2': '谷歌身份驗證器是一款動態口令工具，工作原理類似短信動態驗證。綁定後每30s生成一個動態驗證碼，驗證碼可用於登錄、提現、修改安全設置等操 作的安全驗證。 ',
  'labels.acc.ga.desc3': '使用谷歌驗證器掃描下圖維碼',
  'labels.acc.ga.desc4': '如果您無法掃描二維碼，可以將以下16位密鑰手動輸入到谷歌驗證APP中',
  'labels.acc.ga.desc5': '密鑰用於手機更換或遺失時找回谷歌驗證器，綁定前請務必將下述密鑰備份保存',
  'labels.acc.ga.setupSuccess': '谷歌驗證已成功設置',
  'labels.acc.ga.step1': '下載並安裝谷歌驗證器APP',
  'labels.acc.ga.step2': '掃描二維碼',
  'labels.acc.ga.secret': '秘鑰',
  'labels.acc.ga.device': '設備名稱',
  'labels.acc.notBind': '未綁定',
  'labels.acc.bind': '已綁定',
  'labels.acc.loginPwd': '登錄密碼',
  'labels.acc.loginPwd.desc': '用於系統登錄，為了您的資產安全，登錄密碼修改後24H以內不允許提幣或場外交易。 ',
  'labels.acc.loginPwd.set': '設置登錄密碼',
  'labels.acc.loginPwd.update': '修改登錄密碼',
  'labels.acc.loginPwd.oldPwd': '舊登錄密碼',
  'labels.acc.loginPwd.newPwd': '新登錄密碼',
  'labels.acc.loginPwd.confirmNewPwd': '確認新登錄密碼',
  'labels.acc.loginPwd.confirmPwd': '確認登錄密碼',
  'labels.acc.loginPwd.googleValid': '谷歌驗證',
  'labels.acc.ga.txt.1': '系統檢測到您還未設置谷歌驗證，請先',
  'labels.acc.ga.setup': '設置谷歌驗證！',
  'labels.acc.idVerf': '身份認證',
  'labels.acc.idVerf.rejected': '已被拒絕',
  'labels.acc.idVerf.verified': '已認證',
  'labels.acc.idVerf.pending': '等待審批',
  'labels.acc.idVerf.plsCompLvl1': '先完成等級1認證',
  'labels.acc.idVerf.verifyNow': '去認證',
  'labels.acc.idVerf.maxRegist': '使用MAX-Wallet認證',
  'labels.acc.idVerf.lvl1': '等級1',
  'labels.acc.idVerf.lvl1.desc': '身份或護照證明及活體認證。 ',
  'labels.acc.idVerf.lvl2': '等級2',
  'labels.acc.idVerf.lvl2.desc': '高級認證',
  'labels.acc.txnPwd': '交易密碼',
  'labels.acc.confirmTxnPwd': '確認交易密碼',
  'labels.acc.partnership': '合夥人計劃',
  'labels.acc.partnership.desc': 'Please ask word to display',
  'labels.acc.partnership.pendingUpgrade': '等待升級{title}',
  'labels.acc.partnership.expiredUpgrade': '已到期日',
  'labels.acc.txnPwd.desc': '賬戶資金變動時，需先驗證交易密碼。 ',
  'labels.acc.txnPwd.desc2': '用於登錄、交易、內部轉賬、提幣，賬戶資金變動時，先驗證交易密碼。 ',
  'labels.acc.txnPwd.setup': '設置交易密碼',
  'labels.acc.txnPwd.modify': '修改交易密碼',
  'labels.acc.txnPwd.old': '舊交易密碼',
  'labels.acc.txnPwd.new': '新交易密碼',
  'labels.acc.txnPwd.confirmNew': '確認新交易密碼',
  'labels.acc.mobile.verf': '手機驗證',
  'labels.acc.bindNow': '立即綁定',
  'labels.acc.unbindNow': '解除綁定',
  'labels.acc.notSetup': '未設置',
  'labels.acc.setup': '已設置',
  'labels.acc.side.affiliate': '會員計劃',
  'labels.acc.side.accMsgs': '賬戶信息',
  'labels.acc.side.accMgmt': '帳號管理',
  'labels.acc.side.mobileVerf': '手機驗證',
  'labels.acc.side.idVerf': '身份認證',
  'labels.acc.side.userCenter': '個人中心',
  'labels.acc.side.loginRecord': '登錄記錄',
  'labels.acc.side.relationTree': '會員關係表',
  'labels.acc.side.myReward': '我的獎賞',
  'labels.acc.invite.desc1': '邀請好友註冊GRXTrade，輕鬆獲得交易手續費和年費返佣',
  'labels.acc.invite.desc2': '輕鬆獲得好友手續費20%返佣福利、會員年費20%返佣福利',
  'labels.acc.invite.step1.desc1': '發送邀請給好友',
  'labels.acc.invite.step1.desc2': '通過分享鏈接/二維碼/邀請碼註冊GRXTrade',
  'labels.acc.invite.step2.desc1': '好友註冊',
  'labels.acc.invite.step2.desc2': '好友接受邀請完成註冊並進行幣幣交易',
  'labels.acc.invite.step3.desc1': '獲得相應比例返佣',
  'labels.acc.invite.step3.desc2': '輕鬆獲得好友交易手續費返佣和年費會員返佣',
  'labels.acc.invite.enterCode': '輸入邀請碼',
  'labels.acc.invite.inexchangabledesc': '在完成邀請新用戶註冊後，用戶本身的推薦碼將不能更改',
  'labels.acc.invite.code': '邀請碼',
  'labels.acc.invite.qrCode': '二維碼',
  'labels.acc.invite.download.qrCode': '下載二維碼',
  'labels.acc.invite.mySharing': '我的專屬分享方式',
  'labels.acc.invite.registerLink': '註冊鏈接',
  'labels.acc.invite.registerTotal': '邀請總人數',
  'labels.acc.invite.kycTotal': '實名認證人數',
  'labels.acc.invite.activityDetail': '活動細則',
  'labels.acc.invite.downlineAcc': '被邀請人賬號',
  'labels.acc.invite.noReferral': `没有邀請人?`,
  'labels.acc.invite.noReferral.confirm': `您確定您沒有邀請人添加?`,
  'labels.acc.invite.history': '邀請記錄',
  'labels.acc.inboxMsg.notification': '通告',
  'labels.acc.inboxMsg.readMsg': '已讀消息',
  'labels.acc.inboxMsg.unreadMsg': '未讀消息',
  'labels.acc.inboxMsg.msg': '消息詳情',
  'labels.acc.inboxMsg.title': '標題',
  'labels.acc.inboxMsg.deleteMsg.title': '刪除消息',
  'labels.acc.inboxMsg.deleteMsg.desc': '確定刪除消息?',
  'labels.acc.loginRecord.loginIp': 'IP地址',
  'labels.acc.loginRecord.security': '安全設定',
  'labels.acc.loginRecord.tag1': '登錄歷史',
  'labels.acc.loginRecord.tag2': '安全設置歷史',
  'labels.acc.maxRegister': '授权MAX-Wallet登录',
  'labels.acc.side.maxRegister': '授權MAX-Wallet登錄',
  'labels.acc.maxRegister.desc': '',
  'labels.acc.maxRegister.setupSuccess': '你已經成功綁定MAX-Wallet',

  'landing.appForm.title': `感谢您对<span style="font-family:'Open Sans', sans-serif;font-weight: 100;">GRXTrade</span>的关注！ `,
  'landing.appForm.desc': `请使用真实有效的信息填写此申请表，填写完成后，请将申请表提交至：<a class="color-blue" href="mailto:support@grxtrade.com ">support@grxtrade.com</a>`,
  'landing.appForm.downloadBtn': '在線申請',
  'landing.appForm.about.1': '我们将根据提交的信息对您的项目进行审核。如果信息不一致，或者经我方查询发现存在无效或虚假的信息，您向GRXTrade提出的项目上市请求将被拒绝。 ',
  'landing.appForm.about.2': '如果您对初始审核无异议，我们将会为您分配一名客户经理，以跟进整个上市流程。 ',
  'landing.appForm.tip.title': '注意事项：',
  'landing.appForm.tip.1': '完整地填寫表格，並提供具體示例。避免誇張或模糊的表述。',
  'landing.appForm.tip.2': '以合乎邏輯的方式連貫地組織您的觀點，並提供可信的，可獨立核實的證據。',
  'landing.appForm.tip.3': '此在線上市申請表為申請加入GRXTrade交易平台的唯一途徑。不要通過其他渠道（例如電子郵件或社交媒體）聯繫我們，因為您將始終被引導至該表單。',
  'landing.appForm.tip.4': '請避免通過社交媒體或私人電子郵件/其他GRXTrade部門向我們的團隊成員重複發送多個請求。因為這樣做實際上會使等待人數過大，從而延長服務響應時間。',
  'landing.appForm.tip.5': '我們強烈建議您，不要繼續提交此表格的契機來發送垃圾郵件（或煽動其他個體代表您這樣做），因為這將導致您的項目被列入黑名單。',

  'labels.acc.myRwd.tradingBonus': '交易贈金',
  'labels.acc.myRwd.enjoyNow': '享受100％的交易活動年費回贈',
  'labels.acc.myRwd.digitalClubReward': '課程福利',
  'labels.acc.myRwd.howRedeem': '如何免費兌換課程？ ',
  'labels.acc.myRwd.clickHere': '點擊查看',
  'labels.acc.myRwd.access': '課程由合作講師團隊推出，僅供GRXTrade頂級/高級會員/合夥人學習使用。',
  'labels.acc.myRwd.access-2.1': `如想了解更多免費課程，下載最新版本`,
  'labels.acc.myRwd.access-2.2': `，然後查詢GRXTrade，大量的免費課程等待著你參與。`,
  'labels.acc.myRwd.access.dclub': '俱樂部APP',
  'labels.acc.myRwd.download.app': '下載DCLUB',
  'labels.acc.myRwd.trustedTeam': '可信團隊培訓',
  'labels.acc.myRwd.commission': '所分享的佣金',
  'labels.acc.myRwd.memberFee': '培訓費',
  'labels.acc.myRwd.couponCode': '兌換碼:',
  'labels.acc.myRwd.expiredDate': '截止日期:',
  'labels.acc.myRwd.understandMore': '了解更多',

  'landing.market.title': '一切幣幣交易在你手中',
  'landing.video.title': '下一代數字資產金融服務提供商',
  'landing.market.viewMore': '查看更多',
  'landing.exp.title': '體驗一站式數字資產交易平台',
  'landing.exp.title.desc': 'GRXTrade是以用戶為中心的最新數字資產交易平台，提供市場上極具競爭力的交易費用。讓用戶在平台裡享有最佳利益。',
  'landing.exp.sec.1': '為所有數字資產交易需求的一站式解決方案中心',
  'landing.exp.sec.2': '市場上最低的交易手續費',
  'landing.exp.sec.3': '全面會員計劃',
  'landing.exp.sec.4': '優質的平台安全功能',
  'landing.exp.sec.5': '客戶支持服務',
  'landing.exp.desc.1': '提供多種交易選項和最受歡迎的交易對',
  'landing.exp.desc.2': '高競爭力的交易手續費，低至0.04％',
  'landing.exp.desc.3': '通過活躍推薦者獲取40％的被動佣金收入',
  'landing.exp.desc.4': '與CipherTrace®和MAX-Wallet系統整合',
  'landing.exp.desc.5': '提供快速響應時間的高效客戶服務',
  'landing.exp.whyG.1': '計劃憑藉最優的市場交易費用和最受歡迎的交易對來服務於國際市場交易者，從而提升交易所的運作水平。本交易所平台將通過與其他交易所網絡共享流動性，消除低流動性所帶來的風險。 ',
  'landing.exp.whyG.2': '無論你是高級交易者還是交易新手，GRXTrade都將賦予您打造專屬金融交易路線的能力。我們的交易所提供越來越多的密碼貨幣交易對供您投資，還將為您帶來一系列工具和功能，以豐富您的投資組合。 ',
  'landing.exp.whyG.3': 'GRXTrade是以用戶為主的平台。在這個行業中，我們了解安全性對用戶的重要。為了加強保護，我們與強大的合作夥伴合作，以增加信任度和安全性。 ',
  'landing.exp.whyG.subtitle1.desc': '您可以安全控制您的數字資產。 GRXTrade運用了MAX-Wallet的科技。這是一種在於Maxonrow區塊鏈構建的移動應用程序，其以創新的實名KYC和AML兼容機製而聞名。 ',
  'landing.exp.whyG.subtitle2.desc': 'CipherTrace是由經驗豐富的矽谷企業家領先創立以及數字資產情報為主，以實現蓬勃發展的區塊鏈的經濟。它旨在開發數字資產和區塊鏈跟踪和安全功能為主。 ',
  'landing.exp.whyG.4': '現在就加入GRXTrade，為您的未來投資。 ',
  'landing.getStarted.title': '開始免費使用GRXTrade吧',
  'landing.getStarted.desc': '使用我們的Android和iOS應用程序與最新的圖表和市場保持聯繫，或者您可以使用我們的Mac或Windows專業交易應用程序從台式機進行交易。 ',
  'landing.getStarted.sec.1': '管理您喜歡的市場',
  'landing.getStarted.sec.2': '安全認證',
  'landing.getStarted.sec.3': '幣幣交易',
  'landing.getStarted.desc.1': '所有數字資產交換功能都在您的掌中。',
  'landing.getStarted.desc.2': '多重身份認證，KYC機制，登錄安全保護，錢包定期維護。',
  'landing.getStarted.desc.3': '我們的高流動性交換可確保您的交易訂單以所需的價格快速執行。',
  // 'landing.think.title': '還需要考慮？ ',
  'landing.think.title.desc': '開始探索GRXTrade平台的額外功能',
  'landing.think.sec.1': '會員計劃',
  'landing.think.sec.1.coming': '（敬請期待）',
  'landing.think.sec.2': '手續費',
  'landing.think.desc.1': '立即了解有關我們會員計劃的更多信息',
  'landing.think.desc.2': '熟悉我們的交易手續費結構',
  'landing.partner.join': '加入',
  'landing.partner.title': '合作夥伴',
  'landing.partner.cipher.text': '領先的區塊鏈安全合規品牌，保障您的交易安全與合規性',
  'landing.partner.wallet.text': 'CipherTrace®，可信賴的區塊鏈安全企業，增進數字資產經濟的信任與安全',
  'landing.partner.wallet.link': 'MAX-Wallet',

  'login.welcome': '歡迎登錄',
  'login.forgotPwd': '忘記密碼',
  'login.loggingIn': '登錄中',
  'login.registerForFree': '免費註冊',
  'login.dontHaveAcc': '還沒有賬戶？ ',
  'login.success': '您已成功登錄',
  'login.userActivation': '用户激活',

  'market.list.table.header.pair': '市場',
  'market.list.table.header.lastPrice': '最新成交價',
  'market.list.table.header.24HChange': '今日漲跌',
  'market.list.table.header.24HHigh': '24H最高價',
  'market.list.table.header.24HLow': '24H最低價',
  'market.list.table.header.24HVol': '24H成交量',

  'max.register.title.login': 'MAX-Wallet登錄',
  'max.register.title.registration': 'MAX-Wallet註冊',
  'max.register.title.kyc': '實名認證(MAX-Wallet)',
  'max.register.title.bind': 'MAX-Wallet',
  'max.register.desc.login': '使用MAX-Wallet登錄或在此下載',
  'max.register.desc.bind': '授权MAX-Wallet登錄或在此下載',
  'max.register.desc.registration': '使用MAX-Wallet註冊或在此下載',
  'max.register.desc.kyc': '若繼續，MAX-Wallet將與grxtrade.com分享您的個人信息。',
  'max.register.subDesc.kyc': `在使用此應用之前，請您閱讀我們的<a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">使用條款</a>。`,
  'max.register.question': '有疑問? 請到訪我們的',
  'max.register.helpCenter': '幫助中心',
  'max.register.iAgree': '我同意給予GRXTrade實名認證的資料',
  'max.register.step1': '打開 MAX-Wallet',
  'max.register.step2': '在頂部菜單上',
  'max.register.step3': '將相機對准上方的二維碼',


  'promoMaxRegModal.title': '歡迎體驗簡易註冊',
  'promoMaxRegModal.desc': '為了方便您快速登錄GRXTrade，我們建議您用MAX-Wallet進行註冊。',
  'promoMaxRegModal.explain': 'MAX-Wallet*用戶可在GRXTrade享受：',
  'promoMaxRegModal.benefit1': '一鍵註冊',
  'promoMaxRegModal.benefit2': '一鍵登錄',
  'promoMaxRegModal.benefit3': '即時KYC審核通過',
  'promoMaxRegModal.benefit4': '減少重複繁雜的認證提交和登入程序',
  'promoMaxRegModal.benefit5': '可享有持續開發的新功能對接',
  'promoMaxRegModal.benefit6': '* 須更新最新版本MAX-Wallet',
  'promoMaxRegModal.unableDownload': '無法下載應用程序？',
  'promoMaxRegModal.downloadLink': `<span style ="font-size:14px">請嘗試<a href="{ios}" target="_blank" style="color: #1E49AC">下載iOS系統IPA格式文件</a>或<a href="{android}" target="_blank" style="color: #1E49AC">安卓系統APK格式文件</a></span>`,
  'promoMaxRegModal.downloadNow': '下載MAX-Wallet',
  'promoMaxRegModal.registerPage': `返回郵箱註冊`,
  'promoMaxRegModal.continueWithMaxWallet': '使用MAX-Wallet',
  'promoMaxRegModal.here': '這裡',

  'partnerInvite.joinPartnerProgram.desc': '若要繼續，MAX-Wallet將與grxtrade.com共享您的身份信息。在使用此應用之前，您可以查看我們的使用條款。 ',
  'partnerInvite.joinPartnerProgram.partnerLevel': '合夥級別：',
  'partnerInvite.joinPartnerProgram.fee': '培訓費：',
  'partnerInvite.joinPartnerProgram.termsAndCondition': '在此點擊此按鈕，即表示您同意合夥人計劃的<a href="/legal/partner-policy" target="_blank" style="color: #1E49AC">條款與條件</a>',
  'partnerInvite.joinPartnerProgram.balance': '我的資產餘額：',
  'partnerInvite.joinPartnerProgram.mustCheckText': '您必須同意條款和條件才能繼續進行',

  'maxRegisterModal.title': '使用MAX-Wallet註冊',
  'maxRegisterModal.desc': '如果您已在MAX-Wallet完成實名認證(KYC)，您可選擇用MAX-Wallet註冊並在GRXTrade完成即時實名認證。',
  'maxRegisterModal.scanQrCode': '請用MAX-Wallet掃描以下的二維碼開始註冊',
  'maxRegisterModal.agreeAndContinue': '同意KYC註冊',
  'maxRegisterModal.registerWithoutKyc': '註冊但不提交KYC',

  'register.registration': '歡迎註冊',
  'register.registration.select': '請先選擇，進入下一步。',
  'register.registration.withEmail': '此設備沒有安裝MAX-Wallet',
  'register.registration.withMaxWallet': '此設備已經安裝MAX-Wallet',
  'register.inviteCode': '邀請碼（選填）',
  'register.alreadyRegist': '已有賬戶？ ',
  'register.termAndUsePrivacyPolicy': `創建帳戶，即表示我同意GRXTrade的<a href="/legal/terms-of-use" target="_blank" style="color: #1E49AC">使用條款</a>和<a href="/legal/privacy-policy" target="_blank" style="color: #1E49AC">隱私政策</a>。`,
  'register.success': '恭喜您，註冊成功！',

  'trade.buy.success': '交易成功',
  'trade.sell.success': '交易成功',
  'trade.cancel.confirm': '您確定要撤銷此訂單？ ',
  'trade.cancel.success': '訂單撤銷成功！ ',
  'trade.match.success': '訂單已經匹配! {number}',

  'v.r.advance.address.building': '建築號碼不能為空',
  'v.r.advance.address.street': '街不能為空',
  'v.r.advance.address.district': '區域不能為空',
  'v.r.advance.address.province': '省不能為空',
  'v.r.advance.address.zipCode': '郵政號碼不能為空',
  'v.r.advance.address.city': '市不能為空',
  'v.r.advance.address.countryCode': '國家不能為空',
  'v.r.advance.address.authImgUrl1': '地址證明文件不能為空',
  'v.advance.submit.success': '高級認證提交成功',
  'v.advance.submit.error': '請先保存居住地址和就業資料',

  'v.common.pwd.required': common.plsEnter + '密碼',
  'v.common.pwd.pwdValid': '密碼格式錯誤，密碼長度必須在6-20位之間並包含大寫字母+小寫字母+數字',
  'v.common.pwd.pwdValid.note': '密碼長度必須在6-20位之間並包含大寫字母+小寫字母+數字',
  'v.common.oldPwd.required': common.plsEnter + '旧密碼',
  'v.common.newPwd.required': common.plsEnter + '新密碼',
  'v.common.secondPwd.required': '請再次輸入密碼',
  'v.common.secondPwd.sameAs': '兩次密碼輸入不一致',
  'v.common.txnPwd.required': common.plsEnter + '交易密碼',
  'v.common.txnPwd.format': '密碼格式錯誤，密碼長度必須在6-20位之間並包含大寫字母+小寫字母+數字',
  'v.common.txnPwd.format.note': '密碼長度必須在6-20位之間並包含大寫字母+小寫字母+數字',
  'v.common.txnPwd.notsame': '新交易密碼不能與舊交易密碼一致',
  'v.common.txnPwd.retype': '請再次輸入交易密碼',
  'v.common.payPwd.wrong': '密碼格式錯誤，密碼長度必須等於6',
  'v.common.email.required': common.plsEnter + '郵箱',
  'v.common.email.format': '請輸入正確的郵箱地址',
  'v.common.otp.required': common.plsEnter + '驗證碼',
  'v.common.otp.verifyCode': '請輸入正確的郵箱驗證碼',
  'v.common.country.required': common.plsSelect + '國家',
  'v.common.gaCode.required': common.plsEnter + '谷歌驗證碼',
  'v.common.gaCode.format': '請輸入正確的谷歌驗證碼',
  'v.common.invite': '請填寫邀請碼',
  'v.common.kyc': '請先完成實名認證',
  'v.common.cannot.blank': '不能為空',
  'v.common.ga.setup': '執行此操作之前，您必須先設置谷歌身份驗證',
  'v.common.mobile.required': common.plsEnter + '您的手機號',
  'v.common.mobile.format': '手機號碼格式不正確',
  'v.common.newMobile.required': common.plsEnter + '新手機號',
  'v.common.newMobile.cannot.same': '新手機號與舊手機號不能一致',
  'v.common.setup.ga.before.trade': '請在交易之前設置谷歌身份驗證',
  'v.common.setup.txnPwd.before.trade': '請在交易之前設置交易密碼',
  'v.common.walletAddr.format': '請輸入正確的地址',
  'v.common.session.timeout': '登入已超時',

  'v.trade.volume.required': common.plsEnter + '數量',
  'v.trade.price.required': common.plsEnter + '價格',
  'v.trade.price.min': '最低價格:{priceMin}',
  'v.trade.price.max': '最高價格:{priceMax}',
  'v.trade.amount.insufficientBalance': '餘額不足',

  'success.copy': '複製成功',
  'success.resetPwd': '密碼重置成功!',
  'success.reactivatePwd': '您的帳戶已被重新激活',
  'success.withdraw': '提幣成功',
  'success.withdraw.cancel': '提幣已被撤銷',
  'success.wallet.add': '地址添加成功',
  'success.wallet.delete': '地址刪除成功',
  'success.ga.bind': '谷歌驗證綁定成功',
  'success.ga.unbind': '谷歌驗證解除綁定成功',
  'success.invite': '邀請碼添加成功',
  'success.loginPwd.set': '登錄密碼設置成功',
  'success.loginPwd.modify': '登錄密碼修改成功',
  'success.phone.bind': '手機號碼綁定成功',
  'success.phone.unbind': '手機號解除綁定成功',
  'success.order.place': '成功下單',
  'success.txnPwd.set': '交易密碼設置成功！',
  'success.deleteMsg': '消息已成功刪除',
  'success.bindMAXWallet': '綁定MAX-Wallet成功',
  'success.allOrderCancel': '批量撤銷成功',
  'success.affiliateInvite': '您的申請已批准。',
  'success.partnerInvite': '您的申請已批准。',
  'success.partnerInvite2': '您已成功提交申請。',
  'success.rejectPartnerInvitation': '您已成功拒絕邀請。',
  'success.verifyBtn': '發送驗證碼成功',

  'teamProfile.title': '公司管理層',
  'teamProfile.person1': 'RYAN FELLAL',
  'teamProfile.person1.position': '首席執行官',
  'teamProfile.desc.1': `Ryan，金融衍生產品領域行業專家，精通於為超高淨值人士（UHNWI）、企業及私人機構提供定制化風險管理和融資解決方案。起初，Ryan在著名的瑞士信貸集團（Credit Suisse，總部位於瑞士蘇黎世）展開其衍生品領域職業生涯，隨後成為申展（上海）商務信息諮詢有限公司（知名的英國財富管理公司St. James's Place Wealth Management位於上海的分支）副合夥人。`,
  'teamProfile.desc.2': `Ryan為人處事客觀正直，擅長於多樣化環境下的對外溝通與交流；同時，作為一名結果導向型的專業職場人士，Ryan以其為客戶提供的優質服務而廣受認可。此外，他還是一位“亞洲通”，經常因工作之契機前往多個亞洲和東南亞國家，因而對豐富多彩的東方文化和悠久的歷史傳統有著全面的了解和深深的敬意。`,
  'teamProfile.desc.3': `目前，Ryan以GRXTrade首席執行官的身份加入公司，為GRXTrade平台帶來了其全方位的投資和金融服務諮詢領域經驗，必將帶領企業及其產品進入一個全新的發展高度。`,

  'warning.exceededPrice': '您的價格超出當前價格(PERCENTAGE)',

  'dClub.title': 'DCLUB',
  'dClub.desc.1': 'GRXTrade為您提供免費的DCLUB學習機會。',
  'dClub.desc.2': '無法下載應用程序？',
  'dClub.step1': '點擊下載APP',
  'dClub.step2': '註冊賬號，登錄賬號',
  'dClub.step3': '點擊“我的”，選擇“兌換碼”',
  'dClub.step4': '輸入兌換碼，兌換課程即可',
  'dClub.hyperLink': `<span style ="font-size:14px">請嘗試<a href="{ios}" target="_blank" style="color: #1E49AC">下載iOS系統IPA格式文件</a>或<a href="{android}" target="_blank" style="color: #1E49AC">安卓系統APK格式文件</a></span>`,

  'registerSuccessfulModel.title': '恭喜你！',
  'registerSuccessfulModel.desc': '您的帐户已创建成功！ <div>我们建议您立即下载GRXTrade移动应用程序！ </div>',
  'registerSuccessfulModel.unableToDownloadDesc': '无法下载应用程序？ ',
  'registerSuccessfulModel.hyperLink': '请尝试<a style="color: #1E49AC;">下载iOS IPA </a>或<a style="color: #1E49AC;">下载Android APK </a>',

  'downloadBox.title': 'GRXTrade App 应用程序',

  'invitationPoster.registerNow': '立即註冊',

  "actions.next": "下一步",
  "actions.payAndSubmit": "支付並提交",
  "actions.viewFile": "查看文檔",
  "actions.describeProject": "描述你的專案",
  "actions.upload": "上傳",
  "actions.chooseOrCreateToken": "選擇或創建您的令牌",
  "actions.startOver": "重新開始",
  "actions.continue": "繼續",
  "common.search": "搜索",
  "common.share": "分享",
  "common.viewMore": "查看更多",
  "common.viewLess": "減少查看",
  "common.overview": "概述",
  "common.promoCode": "推廣碼",
  "labels.tokenName": "令牌名稱",
  "labels.tokenSymbol": "令牌符號",
  "labels.mxwToken": "Max-Wallet令牌",
  "labels.free": "免費",
  "labels.tokenRequestFee": "令牌申請手續費",
  "labels.erc20Token": "ERC-20令牌",
  "labels.success": "成功",
  "labels.fail": "失敗",
  "labels.backToHome": "返回主頁",
  "labels.backToPayment": "返回至付款頁",
  "sto.form.required": "此項為必填項",
  "sto.form.numeric": "僅限數字",
  "sto.form.alpha": "僅限字母",

  "sto": "證券型通證發行",
  "sto.applySto": "申請新的STO",
  "sto.myDashboard": "我的介面",
  "sto.myApplication": "我的應用",
  "sto.myProject": "我的專案",
  "sto.myInvestment": "我的投資",
  "sto.ongoing": "進行中",
  "sto.ended": "已結束",
  "sto.ongoingPreSale": "進行中的私募預售",
  "sto.remainingDays": "將在{remainingDays}天內結束",
  "sto.remainingDays2": "還剩{remainingDays}天",
  "sto.updateRequestSent": "更新請求已發送",
  "sto.unableToEdit": "無法編輯",
  "sto.editProject": "編輯專案",
  "sto.updateRequestRejected": "您的更新請求已被拒絕",
  "sto.backToProject": "返回專案",
  "sto.saveProject": "保存專案",
  "sto.updateRequestRejected2": "您的申請因以下原因被拒絕",
  "sto.fundraisingBy": "籌資活動發起方",
  "sto.changePhoto": "更改圖片",
  "sto.uploading": "上傳文檔",
  "sto.tokenPhoto": "令牌圖片",
  "sto.companyOverview": "公司簡介",
  "sto.tokenDetail": "令牌詳情",
  "sto.tokenSymbol": "符號",
  "sto.tokenType": "令牌類型",
  "sto.document": "文檔",
  "sto.businessProposal": "業務計畫書",
  "sto.uploadDocument": "上傳文檔",
  "sto.selectDocument": "選擇文檔",
  "sto.updateDetailReason": "更新詳情的原因",
  "sto.reason": "原因",
  "sto.dates": "STO日期",
  "sto.currentStage": "當前進展",
  "sto.funding": "提供資金",
  "sto.forSale": "待售",
  "sto.raised": "已籌集",
  "sto.addToWatchList": "添加至關注列表",
  "sto.minInvestment": "最低購買",
  "sto.investAmount": "購買數量",
  "sto.investNow": "立即購買",
  "sto.chooseYourToken": "選擇您的令牌",
  "sto.listing.about.about1": "證券型通證是一種旨在促進市場流動性的基礎架構解決方案，相當於傳統紙質票據的電子化、數位化工具，類似於電子郵件與傳統紙質信件之間的關係。",
  "sto.listing.about.about2": "雖然現階段尚不具備在全球範圍內推廣證券型通證所需的基礎條件，但目前已有企業正嘗試利用這一全新的區塊鏈行業趨勢，構建創新型服務。",
  "sto.listing.about.about3": "進入本平臺前，請閱讀並同意GRXTrade使用條款和隱私政策。對於因使用上述服務而造成的任何損失或損害，GRXTrade概不負責。",
  "sto.listing.about.agree": "我已閱讀並確認該通知",
  "sto.listing.about.enter": "進入",
  "sto.listing.pagination.totalRecord": "共找到{totalRecords}個證券型通證發行專案",
  "sto.listing.menu.allSto": "所有STO",
  "sto.listing.menu.whatIsSto": "STO簡介",
  "sto.project.editNotice": "提交後的3-5日內，您將無法編輯該專案。",
  "sto.fundraiser.application.title": "STO籌資申請表",
  "sto.form.companyDetais": "公司介紹",
  "sto.form.shareholderDetails": "股東基本情況",
  "sto.form.directorDetails": "董事基本情況",
  "sto.form.fundraisingDetails": "籌資詳情",
  "sto.form.allFieldsRequired": "此項為必填項",
  "sto.form.countryIncorp": "企業註冊國家或地區",
  "sto.form.companyRegNo": "公司註冊號碼",
  "sto.form.bizNature": "業務性質",
  "sto.form.companyMemorandum": "公司組織大綱/章程/憲法或任何其他同等效力文檔",
  "sto.form.companyCert": "公司註冊證書",
  "sto.form.address": "地址",
  "sto.form.city": "市",
  "sto.form.state": "州",
  "sto.form.postcode": "郵遞區號",
  "sto.form.country": "國家",
  "sto.form.maxUser": "最多{maxUser}個人",
  "sto.form.shareholderName": "股東姓名",
  "sto.form.identityNo": "身份證件",
  "sto.form.ownershipPercentage": "所有權百分比",
  "sto.form.shareholderDocument": "護照證件的真實副本",
  "sto.form.removeShareholder": "移除股東",
  "sto.form.addShareholder": "添加其他股東",
  "sto.form.totalShareholder": "股東總數",
  "sto.form.totalPercentage": "總百分比",
  "sto.form.directorName": "董事姓名",
  "sto.form.idOrPassport": "身份證號碼/護照號碼",
  "sto.form.uploadIdOrPassport": "上傳身份證號碼/護照號碼",
  "sto.form.addDirector": "添加新的董事",
  "sto.form.removeDirector": "移除董事",
  "sto.form.fundraisingTitle": "籌資標題",
  "sto.form.title": "標題",
  "sto.form.fundUnit": "資金單位",
  "sto.form.totalFundToRaise": "籌資總額",
  "sto.form.tokenToRaise": "令牌發行數量",
  "sto.form.tokenToKeep": "令牌發行數量",
  "sto.form.fundraisingDuration": "籌資期限",
  "sto.form.fundraising.successCriteria": "成功籌資標準",
  "sto.form.fundraising.successCriteria2": "可接受的最低籌資金額",
  "sto.form.underwriterCommission": "承銷商傭金",
  "sto.form.underwriterCommission2": "占籌資總額的 %",
  "sto.form.affiliateCommission": "會員計畫傭金",
  "sto.form.affiliateCommission2": "占籌資總額的 %",
  "sto.form.commissionNote": "注：為使籌資活動順利進行，籌資人應選擇將一定比例的籌資金額作為傭金發放給計畫推薦新投資者參與該專案的會員。",
  "sto.form.investmentValueLabel": "投資者的投資價值",
  "sto.form.minInvestAmt": "最小投資價值",
  "sto.form.maxInvestAmt": "最大投資價值",
  "sto.form.fundraisingDurationByMonth": "{duration}月",
  "sto.form.document.notes": "STO發行方必須提交一份用於在GRX STO平臺上發佈的商業計畫書，供投資者做出明智的投資決策。此類文檔必須內容準確，不包含虛假和誤導性資訊。",
  "sto.form.document.notes2": "如果發現存在虛假和誤導性資訊，我們保留將STO發行方列入黑名單的權利。",
  "sto.form.document.notes3": "商業計畫書文檔應涵蓋但不限於以下內容：",
  "sto.form.document.notes4": "僅支持docx，jpg，pdf，jpeg，png格式。文檔大小不應超過5MB。",
  "sto.form.bizProposal": "業務介紹/業務模式/獨特價值主張/收入流財務預測（3年和5年）",
  "sto.form.displayPhoto": "顯示照片",
  "sto.form.projSummary": "專案摘要/專案介紹頁面",
  "sto.form.svcLic": "SVC許可證",
  "sto.form.mxw.note": "若選擇繼續，Max-Wallet將與grxtrade.com共用您的身份資訊。在使用此應用程式之前，您可先瞭解grxtrade.com",
  "sto.form.mxw.termOfUse": "使用條款。",
  "sto.form.walletAddress": "錢包地址",
  "sto.form.requesterName": "申請者姓名",
  "sto.form.requesterEmail": "申請者電子郵箱",
  "sto.form.contractAddress": "合約地址",
  "sto.form.crowdSale": "眾籌/ICO/令牌交易地址",
  "sto.form.offUrl": "官方網站網址",
  "sto.form.logoLink": "鏈接至28x28 png格式圖示標誌的下載",
  "sto.form.logoLink2": "Logo下載鏈接",
  "sto.form.officialContractEmail": "官方聯繫人電子郵件地址",
  "sto.form.tokenDesc": "簡短的專案描述（不超過{limit}個字）",
  "sto.form.tokenDesc2": "專案介紹",
  "sto.form.blogLink": "鏈接至Blog",
  "sto.form.redditLink": "鏈接至Reddit",
  "sto.form.slackLink": "鏈接至Slack",
  "sto.form.fbLink": "鏈接至Facebook",
  "sto.form.twitterLink": "鏈接至Twitter",
  "sto.form.btLink": "鏈接至Bitcointalk論壇",
  "sto.form.githubLink": "鏈接至Github",
  "sto.form.telegramLink": "鏈接至Telegram",
  "sto.form.wechatLink": "鏈接至微信",
  "sto.form.linkedInLink": "鏈接至Linkedin",
  "sto.form.discordLink": "鏈接至Discord",
  "sto.form.whitepaperLink": "鏈接至白皮書",
  "sto.form.coinMarketLink": "代幣市值鏈接",
  "sto.form.comment": "評論",
  "sto.form.tokenInfo": "令牌資訊",
  "sto.form.projectSector": "專案行業",
  "sto.form.totalTokenSupply": "令牌總供應量",
  "sto.form.totalCap": "總上限",
  "sto.form.icoStartDate": "ICO開始日期",
  "sto.form.icoEndDate": "ICO結束日期",
  "sto.form.resumeApplication": "重新返回您的應用程式",
  "sto.form.resumeApplication.note": "似乎您已開始創建應用程式。您要繼續還是重新開始？",
  "sto.waitPayment.note": "請稍候，您的訂單正在處理中。請勿關閉頁面。",
  "sto.error.tokenIssueGreaterThanTokenKeep": "必須多於持有的令牌數",
  "sto.error.tokenKeepLessThanTokenRaise": "必須少於所籌集的令牌數",
  "sto.error.lessThanTotalFundToRaise": "必須少於籌集的總金額",
  "sto.error.lessThanMaxInvestAmt": "必須小於最大投資額",
  "sto.error.moreThanMinInvestAmt": "必須超過最小投資額",
  "sto.error.maxLength": "不能超過{limit}個字元",
  "sto.error.maxWords": "不能超過{limit}個字",

  "sto.payment.title": "訂單匯總",
  "sto.payment.orderId": "訂單編號",
  "sto.payment.date": "日期",
  "sto.payment.accountId": "帳戶ID",
  "sto.payment.accountFee": "帳戶手續費",
  "sto.payment.totalAmount": "總帳戶數",
  "sto.payment.tokenFee": "令牌手續費",
  "sto.payment.notes.ga": "要確認您提交的申請，請輸入用於付款的谷歌驗證密碼",
  "sto.payment.notes.txnPwd": "要確認您提交的申請，請輸入用於付款的交易密碼",
  "sto.payment.success": "您已成功提交申請，正在等待審核，可能需要3-5個工作日。",
  "sto.payment.fail": "很抱歉，您的申請付款操作失敗！",
  "sto.payment.orderTxn": "訂單交易",
  "sto.payment.applicationFee": "申請費用",
  "sto.listing.about.title": "STO-證券型通證發行",
  "sto.listing.about.desc.1": "證券型通證是一種旨在促進市場流動性的基礎架構解決方案，相當於傳統紙質票據的電子化、數位化工具，類似於電子郵件與傳統紙質信件之間的關係。",
  "sto.listing.about.desc.2": "雖然現階段尚不具備在全球範圍內推廣證券型通證所需的基礎條件，但目前已有企業正嘗試利用這一全新的區塊鏈行業趨勢，構建創新型服務。",
  "sto.listing.about.desc.3": "進入本平臺前，請閱讀並同意GRXTrade使用條款和隱私政策。對於因使用上述服務而造成的任何損失或損害，GRXTrade概不負責。",
  "sto.listing.banner.apply.txt": "申請新的STO",
  "sto.listing.dashMenu.application": "我的申請",
  "sto.listing.dashMenu.project": "我的專案",
  "sto.listing.dashMenu.investment": "投資",
  "sto.listing.filter.all": "全部",
  "sto.listing.filter.on.going": "進行中",
  "sto.listing.filter.ended": "已結束",
  "sto.listing.filter.search": "搜索",
  "sto.listing.filter.completed": "已完成",
  "sto.listing.filter.myDraft": "我的草案",
  "sto.listing.listBlock.preSale": "進行中的私募預售",
  "sto.listing.listBlock.endIn": "結束於 ",
  "sto.listing.listBlock.days": "天",
  "sto.listing.totalOf": "共計找到 ",
  "sto.listing.token.found": "證券型通證發行專案",
  "sto.listing.menu.all": "全部證券型通證發行專案",
  "sto.listing.menu.intro": "什麼是證券型通證發行?",
  "sto.listing.menu.dashboard": "我的儀錶板",
  "sto.listing.agreement.notice": "我已閱讀並確認該通知",
  "sto.listing.agreement.enter": "進入",
  "sto.details.STO": "證券型通證發行",
  "sto.details.overview.unable.edit": "無法編輯",
  "sto.details.overview.edit.proj": "編輯專案",
  "sto.details.overview.request.rejected": "您的更新請求已被拒絕",
  "sto.details.overview.back.proj": "返回專案",
  "sto.details.overview.save.proj": "保存專案",
  "sto.details.overview.rejected.reason": "您的申請因以下原因被拒絕",
  "sto.details.overview.err": "錯誤",
  "sto.details.overview.campaign.by": "籌資活動發起方",
  "sto.details.overview.campaign.owner": "Marco Neukom",
  "sto.details.overview.chg.photo": "修改照片",
  "sto.details.overview.upload.file": "上傳文檔",
  "sto.details.overview.token.photo": "令牌圖片",
  "sto.details.overview.comp.overview": "公司簡介",
  "sto.details.overview.share": "分享",
  "sto.details.overview.twitter": "推特",
  "sto.details.overview.facebook": "臉書",
  "sto.details.overview.weibo": "微博",
  "sto.details.overview.wechat": "微信",
  "sto.details.overview.telegram": "電報",
  "sto.details.overview.linkedin": "領英",
  "sto.details.overview.token.details": "令牌詳情",
  "sto.details.overview.symbol": "標誌",
  "sto.details.overview.token.type": "令牌類型",
  "sto.details.overview.document": "文檔",
  "sto.details.overview.business.proposal": "商業計畫書",
  "sto.details.overview.upload.document": "上傳文檔",
  "sto.details.overview.reason": "原因",
  "sto.details.overview.submitted.unable.edit": "提交後的3-5日內，您將無法編輯該專案。",
  "sto.details.editModal.display.photo": "顯示圖片",
  "sto.details.editModal.update.reason": "更新詳情的原因",
  "sto.details.nothing.here": "此處空空如也",
  "sto.details.list.overview": "概覽",
  "sto.details.list.overview.sto.dates": "證券型通證發行日期",
  "sto.details.list.overview.current.stage": "當前進展",
  "sto.details.list.overview.funding": "籌資",
  "sto.details.list.overview.for.sale": "待售",
  "sto.details.list.overview.sto.price": "證券型通證發行價格",
  "sto.details.list.overview.raised": "已籌集",
  "sto.details.list.overview.add.watchlist": "添加至關注列表",
  "sto.details.list.overview.promo.code": "推廣碼",
  "sto.details.list.overview.min.investment": "最低投資",
  "sto.details.list.overview.invest.now": "立即投資",
  "sto.error.mustBe": "值必須為{limit}",
  "sto.error.maxSize": "文檔大小已超過{limit}",
  "sto.error.onlyPdf": "文檔類型無效。僅支持圖像格式文檔",
  "sto.error.onlyImage": "文檔類型無效。僅支持PDF格式文檔",
  "sto.error.beforeDate": "必須在{limit}之前",
  "sto.error.afterDate": "必須在{limit}之後",
  "labels.investedAmt": "投資金額",
  "labels.refNo": "參考號",

  'sto.listing.filter.myRework': '我的修訂',
  'sto.labels.requireRework': '該申請需重新修訂',
  'sto.labels.reworkApplySuccess': '修改版申請已提交',
  'sto.labels.isRejected': '此申請已被拒絕',
  'sto.labels.pendingPayment': '待付款',
  'sto.labels.units': '單元'
};
